import type {
  MeetingBodyGetAllResponse,
  MeetingBodyGetBoardMemberPublicResponse,
  MeetingBodyGetMemberPublicResponse,
  MeetingBodyGetOneResponse,
  MeetingBodyMessageInput,
  MeetingBodyPublicGetAllWithMembersResponse,
  MeetingBodySearchInput,
  MeetingBodySearchResponse,
  MeetingBodyStatisticsResponse,
  MeetingBodyVacantSeatSearchInput,
  MeetingBodyVacantSeatSearchResponse,
} from '@govinity/validation/public';

import { ReadOnlyApi } from '../base';

export class MeetingBodiesApi extends ReadOnlyApi<
  MeetingBodyGetAllResponse,
  object,
  MeetingBodySearchInput,
  MeetingBodySearchResponse
> {
  governmentPath: string;
  governmentCode: string;

  constructor(governmentCode: string, governmentPath: string) {
    super();

    this.governmentPath = governmentPath;
    this.governmentCode = governmentCode;
  }

  getPath() {
    return `${this.governmentPath}/${this.governmentCode}/meeting-bodies`;
  }

  async getWithMembers() {
    const { data } = await this.request<MeetingBodyPublicGetAllWithMembersResponse[]>({
      method: 'GET',
      url: `${this.getPath()}/with-members`,
    });

    return data;
  }

  async getMember(memberId: number) {
    const { data } = await this.request<MeetingBodyGetMemberPublicResponse>({
      method: 'GET',
      url: `${this.getPath()}/members/${memberId}`,
    });

    return data;
  }

  async getBoardMember(meetingBodyId: number, memberId: number) {
    const { data } = await this.request<MeetingBodyGetBoardMemberPublicResponse>({
      method: 'GET',
      url: `${this.getPath()}/${meetingBodyId}/members/${memberId}`,
    });

    return data;
  }

  async vacantSeatsSearch(searchParams: MeetingBodyVacantSeatSearchInput) {
    const { data } = await this.request<{
      count: number;
      records: MeetingBodyVacantSeatSearchResponse[];
    }>({
      method: 'POST',
      url: `${this.getPath()}/search-vacant-seats`,
      data: searchParams,
    });

    return data;
  }

  async getById(meetingBodyId: number) {
    const { data } = await this.request<MeetingBodyGetOneResponse>({
      method: 'GET',
      url: `${this.getPath()}/${meetingBodyId}`,
    });

    return data;
  }

  async getStatistics() {
    const { data } = await this.request<MeetingBodyStatisticsResponse>({
      method: 'GET',
      url: `${this.getPath()}/statistics`,
    });

    return data;
  }

  async sendMessage(meetingBodyId: number, contactData: MeetingBodyMessageInput) {
    await this.request<void>({
      method: 'POST',
      url: `${this.getPath()}/${meetingBodyId}/message`,
      data: contactData,
    });
  }
}
